import Vue from 'vue';
import VueRouter from 'vue-router';
import CatalogIndexPage from "./pages/CatalogIndex/CatalogIndexPage";
import ProductDetailPage from "./pages/ProductDetailPage/ProductDetailPage";
import CustomerDashboardPage from "./pages/CustomerDashboard/CustomerDashboardPage";
import CustomerDashboardProfile from "./pages/CustomerDashboard/CustomerDashboardProfile";
import PasswordForgetPage from "./pages/Auth/PasswordForgetPage";
import PasswordResetPage from "./pages/Auth/PasswordResetPage";
import AccountNotVerified from "./pages/Auth/AccountNotVerified";
import LoginPage from "./pages/Auth/LoginPage";
import RegisterPage from "./pages/Auth/RegisterPage";
import HandleRegisterMail from "./pages/Auth/HandleRegisterMail";
import CheckoutPage from "./pages/Checkout/CheckoutPage";
import CheckoutPageLeads from "./pages/Checkout/CheckoutPageLeads";
import FinishCheckoutPageLeads from "./pages/Checkout/FinishCheckoutPageLeads";
import CheckoutThanks from "./pages/Checkout/CheckoutThanks";
import FleetmanagerDashboardPage from "./pages/FleetmanagerDashboard/FleetmanagerDashboardPage";
import AboutSubscription from "./pages/AboutSubscription/AboutSubscription";
import LandingPage from "./pages/Landing/LandingPage";
import Content from "./pages/Content/Content";
import CancelSubscription from "./pages/CancelSubscription/CancelSubscription";
import CancelSubscriptionSucceeded from "./pages/CancelSubscription/CancelSubscriptionSucceeded";
import Error404 from './pages/Errors/Error404';
import {i18n} from './i18n';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        // this fixes scroll to top when changing catalog filters by user input
        // overwriting default scroll behavior because catalog filters are not new page, just appended queries
        if (to.name === 'catalog') {
            if(Object.keys(to.query).length > 0) {
                return
            } else {
                return { x: 0, y: 0 }
            }
        }

        if (to.name === 'pdp') {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {
            path: '',
            name: 'landing-page',
            component: LandingPage,
         },
        {
            path: '/katalog',
            name: 'catalog',
            component: CatalogIndexPage,
            alias: getAlias('catalog', '/katalog')
        },
        {
            path: '/katalog/:slug/:productUuid',
            name: 'pdp',
            component: ProductDetailPage,
            alias: getAlias('pdp', '/katalog/:slug/:productUuid'),
        },
        {
            path: '/uebersicht',
            name: 'cdb-dashboard',
            component: CustomerDashboardPage,
            alias: getAlias('cdb-dashboard', '/uebersicht'),
        },
        {
            path: '/profil',
            name: 'cdb-dashboard-profile',
            component: CustomerDashboardProfile,
            alias: getAlias('cdb-dashboard-profile', '/profil'),
        },
        {
            path: '/anmeldung',
            name: 'login',
            component: LoginPage,
            alias: getAlias('login', '/anmeldung'),
        },
        {
            path: '/registrierung',
            name: 'register',
            component: RegisterPage,
            alias: getAlias('register', '/registrierung'),
        },
        {
            path: '/registrierung-initialisierung',
            name: 'register_init',
            component: HandleRegisterMail,
            alias: getAlias('register_init', '/registrierung-initialisierung'),
        },
        {
            path: '/passwort-vergessen',
            name: 'password_forget',
            component: PasswordForgetPage,
            alias: getAlias('password_forget', '/passwort-vergessen'),
        },
        {
            path: '/passwort-vergessen/:token*',
            name: 'pasword_reset',
            component: PasswordResetPage,
            alias: getAlias('pasword_reset', '/passwort-vergessen/:token*'),
        },
        {
            path: '/account-nicht-bestaetigt',
            name: 'account_not_verified',
            component: AccountNotVerified,
            alias: getAlias('account_not_verified', '/account-nicht-bestaetigt')
        },
        {
            path: '/buchung/:identifier',
            name: 'checkout',
            component: CheckoutPage,
            alias: getAlias('checkout', '/buchung/:identifier')
        },
        {
            path: '/buchung-leads/:identifier',
            name: 'checkout-leads',
            component: CheckoutPageLeads,
            alias: getAlias('checkout-leads', '/buchung-leads/:identifier')
        },
        {
            path: '/finish-leads',
            name: 'finish-leads',
            component: FinishCheckoutPageLeads,
            alias: getAlias('finish-leads', '/finish-leads')
        },
        {
            path: '/vielen-dank/:identifier',
            name: 'checkout-thanks',
            component: CheckoutThanks,
            alias: getAlias('checkout-thanks', '/vielen-dank/:identifier')
        },
        {
            path: '/ueber-das-abo',
            name: 'about-subscription',
            component: AboutSubscription,
            alias: getAlias('about-subscription', '/ueber-das-abo')
        },
        {
            path: '/abo-kuendigen',
            name: 'cancel-subscription',
            component: CancelSubscription,
            alias: getAlias('cancel-subscription', '/abo-kuendigen')
        },
        {
            path: '/abo-erfolgreich-gekuendigt/:hash',
            name: 'cancel-subscription-succeeded',
            component: CancelSubscriptionSucceeded,
            alias: getAlias('cancel-subscription-succeeded', '/abo-erfolgreich-gekuendigt/:hash')
        },
        {
            path: '/fleetmanager-dashboard',
            name: 'fleetmanager-dashboard',
            component: FleetmanagerDashboardPage,
            alias: getAlias('fleetmanager-dashboard', '/fleetmanager-dashboard')
        },
        {
            path: '/:path',
            name: 'content-page',
            component: Content,
        },
        {
            path: '/#/*',
            redirect: ''
        },
        {
            path: '/404',
            alias: '*',
            name: 'not-found',
            component: Error404,
            redirect: ''
        },
    ]
});

function getAlias(pathName, givenPath) {
    const languages = i18n.messages
    let paths = []

    for (const language in languages) {
        const path = '/'+i18n.t(`route.${pathName}.alias`, language)

        if(!paths.includes(path) && path !== givenPath) {
            paths.push(path);
        }
    }

    return paths
}

// error handler
const onError = (e) => {
    // avoid NavigationDuplicated
    if (e.name !== 'NavigationDuplicated') throw e
}

// keep original function
const _push = router.__proto__.push
// then override it
router.__proto__.push = function push(...args) {
    try {
        const op = _push.call(this, ...args)
        if (op instanceof Promise) op.catch(onError)
        return op
    } catch (e) {
        onError(e)
    }
}

router.beforeEach((to, from, next) => {    
    if (process.env.MIX_ENVIRONMENT == 'production' && window.location.protocol === 'http:') {
        let path = to.fullPath != '/route.null' ? to.fullPath : '/' 
        window.location.href = 'https://' + window.location.host + path;
    } else {
        next();
    }
  });

export default router;

